export const CUSTOMER_AGREEMENT_URL = 'https://www.cuverse.com/legal/terms';
